<template>
  <form class="add-room" ref="containerRef" @submit.prevent="onSubmit">
    <button class="add-room__button" v-if="!isForm" @click="onOpenForm">
      <div class="add-room__icon">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="14" cy="14" r="13.5" fill="#498388" stroke="#498388" />
          <path d="M21 15H15V21H13V15H7V13H13V7H15V13H21V15Z" fill="#EEF4F4" />
        </svg>
      </div>
      {{ $t("list.category_add") }}
    </button>
    <div class="add-room__control" v-else>
      <div class="add-room__icon">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="14" cy="14" r="13.5" fill="#498388" stroke="#498388" />
          <path d="M21 15H15V21H13V15H7V13H13V7H15V13H21V15Z" fill="#EEF4F4" />
        </svg>
      </div>
      <label class="add-room__label" for="add-room">
        <input
          id="add-room"
          class="add-room__input"
          placeholder="Nowa kategoria"
          v-model="name"
          ref="inputRef"
        />
      </label>
    </div>
  </form>
</template>

<script setup>
import { ref } from "vue";
import { useClickOutside } from "@/helpsers/click-outside.helpers";

import { useShoppingListStore } from "@/stores/shoppingList.store";

const isForm = ref(false);

const containerRef = ref(null);
useClickOutside(containerRef, (e) => {
  isForm.value = false;
});
const inputRef = ref(null);
function onOpenForm() {
  isForm.value = true;
  setTimeout(() => {
    inputRef.value?.focus();
  }, 0);
}
const props = defineProps({
  projectId: {},
  shoppingListId: {},
});
const name = ref("");
const store = useShoppingListStore();
async function onSubmit() {
  await store.addRoom({
    name: name.value,
    shoppingListId: props.shoppingListId,
  });
  name.value = "";
  isForm.value = false;
}
</script>

<style scoped lang="scss">
.add-room {
  margin-top: 20px;
  padding: 16px 30px;
  background: #eef4f4;
  border-radius: 10px;
  &__button {
    border: none;
    height: 30px;
    margin: 0;
    padding: 0;
    background-color: transparent;
    display: flex;
    align-items: center;
    gap: 14px;
    font-weight: 500;
    font-size: 2.25rem;
    color: #498388;
    opacity: 0.8;
    &:hover {
      opacity: 1;
      cursor: pointer;
    }
  }
  &__icon {
    width: 28px;
    height: 28px;
  }
  &__control {
    display: flex;
    height: 30px;
    align-items: center;
    gap: 14px;
  }
  &__label {
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #cacaca;
    &::after {
      content: url("@/assets/icons/edit-green.svg");
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
  &__input {
    background-color: transparent;
    border: none;
    width: 100%;
    &:focus {
      outline: none;
    }
  }
  &__input,
  &__input::placeholder {
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    font-size: 2.25rem;
    color: #498388;
  }
}
</style>
